import {type RouteRecordRaw} from 'vue-router';
import acquisition from './acquisition';
import project from './project';

const PmsHome = () => import('../../views/pms/index/PmsHome.vue');

let meta: MetaData = {
    module: 'pms',
};

let routes: RouteRecordRaw[] = [];
let pms: RouteRecordRaw[]    = [
    //<editor-fold desc="index">
    // home
    {
        path: '/pms',
        name: 'pms-home',
        component: PmsHome,
        meta,
    },
    // old compatibility routes
    {
        path: '/pms/index',
        redirect: {name: 'pms-home'},
        meta,
    },
    {
        path: '/pms/index/index',
        redirect: {name: 'pms-home'},
        meta,
    },
    //</editor-fold>
];

export default routes.concat(pms, acquisition, project);
